// 封装Axios

// 1.引入Axios
import axios from 'axios'

export function request(config) {
    // 创建实例
    const instance = new axios.create({
        // baseURL: 'https://kendalchina.com'
    })

    //  设置拦截器
    instance.interceptors.request.use(config => {
        return config
    }, error => {
        return Promise.reject(error)
    })

    instance.interceptors.response.use(res => {
        return res.data
    }, error => {
        return Promise.reject(error)
    })

    return instance(config)
}


// WEBPACK FOOTER //
// ./src/api/request.js